import { render, staticRenderFns } from "./com-page-export.vue?vue&type=template&id=6f80c62d&"
import script from "./com-page-export.vue?vue&type=script&lang=js&"
export * from "./com-page-export.vue?vue&type=script&lang=js&"
import style0 from "./com-page-export.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports